<script>
export default {
  components: {},
  props: {
    bgColor: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<template>
  <div :class="['section-wrapper', bgColor ? bgColor : '']">
    <h3 v-if="title" class="section-title">{{ title }}</h3>
    <p v-if="description" class="section-description">{{ description }}</p>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.section-wrapper {
  background-color: $color-off-white;
  padding: 3.2rem 6rem 3.7rem;

  &.white {
    background-color: white;
  }

  .section-wrapper-title {
    // ...
  }
}
</style>
